import { render, staticRenderFns } from "./LaporanClaimTanpaNoLaporan.vue?vue&type=template&id=76b06dab&scoped=true&"
import script from "./LaporanClaimTanpaNoLaporan.vue?vue&type=script&lang=js&"
export * from "./LaporanClaimTanpaNoLaporan.vue?vue&type=script&lang=js&"
import style0 from "./LaporanClaimTanpaNoLaporan.vue?vue&type=style&index=0&id=76b06dab&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b06dab",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VProgressLinear,VRow})
